import { createApi } from '../createApi';
import * as dummy from '../dummy/notifications';
import * as real from '../api/notifications';

const api = createApi(dummy, real);

export const notificationService = {
  /* 서비스 (유저용) */
  getList: api.getNotifications,
  markRead: api.markNotificationRead,

  /* 관리자 */
  adminGetList: api.getAdminNotifications,
  adminSend: api.sendAdminNotification,
};
